module.exports = __webpack_public_path__ + "static/img/partner-sme.90e11a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-sme.png
// module id = gjex
// module chunks = 34